let currentDay = null

function newFilterMarkupPresent() {
  return !!(document.getElementById('seating-filter-wrapper') ||
    document.getElementById('inclusions-filter-wrapper') ||
    document.getElementById('days-filter-wrapper'))
}

function computeVisibleCategories() {
  let categories = new Set()
  let hasDaySelector = !!document.getElementById('days-filter-wrapper')
  if (hasDaySelector && !currentDay) return categories

  document.querySelectorAll('.product-item').forEach(function (item) {
    let seatingChartPackage = item.closest('.seatingChartPackage')
    let groupPackage = item.closest('.group-package')
    let hiddenByPrice = seatingChartPackage && seatingChartPackage.classList.contains('hidden')
    let hiddenByType = groupPackage && groupPackage.classList.contains('pkg-hidden')

    if (!hiddenByPrice && !hiddenByType) {
      let names = (item.getAttribute('data-category-names') || '').split(',')
      names.forEach(function (name) {
        name = name.trim()
        if (name) categories.add(name)
      })
    }
  })

  return categories
}

function updateSeatingInclusionFilters() {
  let categories = computeVisibleCategories()

  ;['seating-filter-wrapper', 'inclusions-filter-wrapper'].forEach(function (id) {
    let wrapper = document.getElementById(id)
    if (!wrapper) return

    wrapper.querySelectorAll('li[data-filter]').forEach(function (li) {
      let checkbox = li.querySelector('input[type=checkbox]')
      if (!checkbox) return
      checkbox.disabled = !categories.has(li.getAttribute('data-filter'))
    })
  })
}

function updateResetButtonState() {
  let resetButton = document.querySelector('.reset')
  if (!resetButton) return

  let hasExtraFilters = Array.from(
    document.querySelectorAll('#seating-filter-wrapper input[type=checkbox], #inclusions-filter-wrapper input[type=checkbox]')
  ).some(function (cb) {
    return cb.checked
  })

  resetButton.disabled = !hasExtraFilters
}

let SELECTED_DAY_CLASS = 'selected-day'

function dayCheckboxes() {
  return Array.from(document.querySelectorAll('#days-filter-wrapper li[data-filter] input[type=checkbox]'))
}

function uncheckOtherDays(selectedCheckbox) {
  dayCheckboxes().forEach(function (checkbox) {
    if (checkbox !== selectedCheckbox) checkbox.checked = false
  })
}

function updateSelectedDayClass(selectedLi) {
  document.querySelectorAll('#days-filter-wrapper li[data-filter]').forEach(function (li) {
    li.classList.toggle(SELECTED_DAY_CLASS, li === selectedLi)
  })
}

function checkDayFilter(day) {
  let checkbox = document.querySelector('#days-filter-wrapper li[data-filter="' + day + '"] input[type=checkbox]')
  if (!checkbox) return
  checkbox.checked = true
  checkbox.dispatchEvent(new Event('change', { bubbles: true }))
}

function updateUrlForDay(day) {
  let url = new URL(window.location.href)
  url.searchParams.set('package-group', day)
  window.history.replaceState({}, '', url)
}

function setPackagesVisible(visible) {
  let gate = document.getElementById('day-selector-packages')
  if (gate) {
    gate.classList.toggle('day-selector-hidden', !visible)
    return
  }

  let wrapper = document.querySelector('#package-selection .package-container-wrapper')
  if (!wrapper) return
  if (visible) {
    wrapper.style.removeProperty('display')
  } else {
    wrapper.style.setProperty('display', 'none', 'important')
  }
}

function updateDaySectionsVisibility() {
  let selectorContainer = document.getElementById('day-selector-container')
  let selectMessage = document.getElementById('select-a-day-message')
  let filterContainer = document.querySelector('#package-selection .filter-container')
  let packagesHeading = document.querySelector('#package-selection h2')

  let daySelectorHiddenBefore = !!selectorContainer && selectorContainer.style.display === 'none'
  let showFilters = !!currentDay || daySelectorHiddenBefore
  let showMessage = !currentDay && daySelectorHiddenBefore

  if (currentDay && selectorContainer) selectorContainer.style.display = 'none'
  if (selectMessage) selectMessage.style.display = showMessage ? '' : 'none'
  if (filterContainer) filterContainer.style.display = showFilters ? '' : 'none'
  if (packagesHeading) packagesHeading.style.display = showFilters ? '' : 'none'
  setPackagesVisible(!!currentDay)

  updateSeatingInclusionFilters()
  updatePriceSliderDisabledState()
}

function updatePriceSliderDisabledState() {
  document.querySelectorAll('#seating_chart_price input[type=range]').forEach(function (input) {
    input.disabled = !currentDay
  })
}

document.addEventListener('change', function (e) {
  if (!e.target.matches || !e.target.matches('#packages-filter .container-fluid input[type=checkbox]')) return
  if (!newFilterMarkupPresent() || !e.target.checked) return

  let daysWrapper = document.getElementById('days-filter-wrapper')
  let li = e.target.closest('li[data-filter]')
  if (daysWrapper && li && daysWrapper.contains(li)) uncheckOtherDays(e.target)
}, true)

document.addEventListener('change', function (e) {
  if (!e.target.matches || !e.target.matches('#packages-filter .container-fluid input[type=checkbox]')) return
  if (!newFilterMarkupPresent()) return

  let daysWrapper = document.getElementById('days-filter-wrapper')
  let li = e.target.closest('li[data-filter]')

  if (daysWrapper && li && daysWrapper.contains(li)) {
    let day = li.getAttribute('data-filter')

    if (e.target.checked) {
      currentDay = day
      updateUrlForDay(currentDay)
      updateSelectedDayClass(li)
    } else {
      currentDay = null
      updateSelectedDayClass(null)
    }

    updateDaySectionsVisibility()
  }

  updateSeatingInclusionFilters()
  updateResetButtonState()
})

document.addEventListener('click', function (e) {
  if (!newFilterMarkupPresent()) return
  if (e.target.closest('.reset') && currentDay) checkDayFilter(currentDay)
})

document.addEventListener('turbo:load', function () {
  let daySelect = document.getElementById('day-selector-input')
  if (!daySelect) return

  function setSelectedDay(day) {
    checkDayFilter(day)
    updateResetButtonState()
  }

  currentDay = new URLSearchParams(window.location.search).get('package-group')
  updateDaySectionsVisibility()

  if (currentDay) {
    setSelectedDay(currentDay)
  } else {
    daySelect.addEventListener('change', function () {
      if (this.value) setSelectedDay(this.value)
    })
  }
})
